
import React from 'react';
import PropTypes from 'prop-types';

import makeChartApi from "../services/chartApi";


const withHighcharts = Composed => {

  const C = (props, context) => {
    if (typeof context.Highcharts !== 'object' || !context.Highcharts) {
      throw new Error(`Check that you've included HighchartsProvider.`);
    }
    const newProps = {
      ...props,
      // interfaced methods that access the Highcharts API - to manage chart
      // creation, updating and destroying etc
      service: makeChartApi(context.Highcharts),
    };
    return <Composed {...newProps} />
  };

  C.contextTypes = {
    Highcharts: PropTypes.object.isRequired,
  };

  return C;
};

export default withHighcharts;

